// @ts-check

import {
  GET_RING_TREES,
  GET_RING_TREE,
  CREATE_RING_TREE,
  UPDATE_RING_TREE,
  GET_RING_TREE_REFERENCES,
  DELETE_RING_TREE,
  GET_RING_TREE_TARGETS
} from './actionTypes';
import { STATUS_PENDING, getActionStatusName } from '@/store/helpers';

export const isFetchingRingTrees = (_, getters) => {
  return (
    getters.getRingTreesStatus.status === STATUS_PENDING ||
		getters.getRingTreeStatus.status === STATUS_PENDING
  );
};
export const isRingTreeReferencesLoading = (_, getters) => {
  return getters.getRingTreeReferencesStatus.status === STATUS_PENDING;
};
export const isRingTreeDeleteLoading = (_, getters) => {
  return getters.deleteRingTreeStatus.status === STATUS_PENDING;
};

export const getRingTreeStatus = (state) =>
  state.status[getActionStatusName(GET_RING_TREE)] || {};
export const getRingTreesStatus = (state) =>
  state.status[getActionStatusName(GET_RING_TREES)] || {};
export const getRingTreeTargets = (state) =>
  state.status[getActionStatusName(GET_RING_TREE_TARGETS)] || {};
export const createRingTreeStatus = (state) =>
  state.status[getActionStatusName(CREATE_RING_TREE)] || {};
export const updateRingTreeStatus = (state) =>
  state.status[getActionStatusName(UPDATE_RING_TREE)] || {};
export const getRingTreeReferencesStatus = (state) =>
  state.status[getActionStatusName(GET_RING_TREE_REFERENCES)] || {};
export const deleteRingTreeStatus = (state) =>
  state.status[getActionStatusName(DELETE_RING_TREE)] || {};
export const getRingTreeTargetsStatus = (state) =>
  state.status[getActionStatusName(GET_RING_TREE_TARGETS)] || {};
export const getDisplayRingTrees = (state, getters) => {
  if (getters.isFetchingRingTrees) {
    return [];
  }
  return state.ringTrees;
};
